import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failures = ['Las calculadoras de lotaje externas son lentas y te hacen perder el precio de entrada.', 'Las señales de Telegram no te enseñan a gestionar el riesgo, solo a depender de otros.', 'El trading manual en momentos de alta volatilidad (NY Open) es una trampa para la psicología humana.', 'Los robots 100% automáticos suelen quemar cuentas porque no entienden el contexto del mercado.'];
export function FailedSolutions() {
  return <section className="py-20 bg-dark border-y border-surfaceHighlight relative" data-id="element-34">
      <div className="absolute inset-0 bg-circuit opacity-5" data-id="element-35"></div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-37">
          <h2 className="font-display text-3xl font-extrabold text-white uppercase tracking-wide" data-id="element-38">
            Por qué lo que has intentado{' '}
            <span className="text-danger" data-id="element-39">no funcionó</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-40">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 glass-panel rounded-sm border-danger/20 hover:border-danger/50 transition-colors" data-id="element-41">
              <XCircleIcon className="w-6 h-6 text-danger shrink-0 mt-1" data-id="element-42" />
              <p className="text-gray-300 leading-relaxed" data-id="element-43">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}